// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3olhO","alert":"SettungsInbox_alert__6MP6W"};